import { GET } from '@/utils/axios'

export const getTheme = async () => {
  const themeName = window.location.hostname.split('.')
  return await GET(`/organization/${themeName[0]}`)
}
